import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'
import { useUser } from '../user/useUser'

export const TEAM_MEMBERSHIPS_QUERY_KEY = (userID: string) =>
  ['teamMemberships', userID] as const

export function useTeamMemberships(userID?: string) {
  const { data: user } = useUser()
  const resolvedUserID = userID || user?.id || ''

  return useQuery({
    queryKey: TEAM_MEMBERSHIPS_QUERY_KEY(resolvedUserID),
    queryFn: () => dataSource.getTeamMemberships(resolvedUserID),
    enabled: !!resolvedUserID,
  })
}
